import { CapoPlugin } from "/home/circleci/project/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.43_typescript@5.5.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];